import { render, staticRenderFns } from "./FilledButton.vue?vue&type=template&id=ffaad460"
import script from "./FilledButton.vue?vue&type=script&lang=js"
export * from "./FilledButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports